export default [
  {
    text: 'Grid with 2 columns',
    description: 'Default layout. Products are displayed in a grid with 2 columns. Each product is displayed with an image.',
    images: true,
    value: '2-grid'
  },
  {
    text: 'List',
    description: 'Products are displayed in a list. Products have no images.',
    images: false,
    value: 'list'
  }
];
